function init() {
    // Textbausteine erstellen/Bearbeiten
    if ($('#dlgTextbaustein').length > 0) {
        initTextbaustein();
    }
    if ($('.dlgTextbausteine').length > 0) {
        initTextbausteine(document);
    }
}

window.initTextbausteine = (ui) => {
    var currentItem = null;
    var dlg_textbaustein = $(ui)
        .find('.dlgTextbausteine')
        .dialog({
            autoOpen: false,
            modal: true,
            width: 520,
            title: 'Textbausteine',
            height: 240,
            maxHeight: 540,
            buttons: [
                {
                    text: 'Ok',
                    class: 'ok',
                    click: function () {
                        var tbId = $(this).find('.drpTextbausteine').val();
                        currentItem.find('input.tbId').val(tbId);
                        // Textbaustein einf�gen
                        $.ajax({
                            type: 'POST',
                            url: '/Handler/HvD/Textblock',
                            data: {
                                data: {
                                    type: 'get',
                                    id: tbId
                                }
                            }
                        })
                            .done(function (data, state, jqxhr) {
                                currentItem.find('.tb-out').html(data);
                            })
                            .fail(function (data, textStatus, errorThrown) {
                                console.debug(textStatus);
                                console.debug(errorThrown);
                            });
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Abbrechen',
                    class: 'cancel',
                    click: function () {
                        $(this).dialog('close');
                    }
                }
            ]
        });
    $('.selectTB').click(function (event) {
        currentItem = $(this).closest('.textboxInsert');
        dlg_textbaustein.dialog('open');
    });
    $('.drpTextbausteine').selectmenu({
        width: 300
    });
};

window.initTextbaustein = () => {
    CKEDITOR.disableAutoInline = true;
    var tbId = 'edit-textbaustein';
    var editRow = null;
    if (!CKEDITOR.instances[jQuery('#' + tbId)[0]]) {
        window.CKEDITOR.inline(jQuery('#' + tbId)[0]);
    }
    // CKEDITOR.inline(jQuery('#' + tbId)[0]);
    var dlg_textbaustein = $('#dlgTextbaustein').dialog({
        autoOpen: false,
        modal: true,
        width: 540,
        title: 'Textbaustein',
        height: 440,
        maxHeight: 540,
        buttons: [
            {
                text: 'Speichern',
                class: 'ok',
                click: function () {
                    var data = CKEDITOR.instances[tbId].getData();
                    postData(data);
                    $(this).dialog('close');
                }
            },
            {
                text: 'Abbrechen',
                class: 'cancel',
                click: function () {
                    $(this).dialog('close');
                }
            }
        ],
        close: function (event, ui) {
            CKEDITOR.instances[tbId].setData('');
            $('#blockTitle').val('');
            $('#blockId').val(0);
        }
    });
    $('.add-txt').on('click', function (event) {
        dlg_textbaustein.dialog('open');
    });

    $('.icon-pencil.editTB').on('click', function (event) {
        $('#blockId').val($(this).attr('data-id'));
        editRow = $(this).closest('.row');
        $('#blockTitle').val(editRow.find('.data-title').text().trim());
        var data = CKEDITOR.instances[tbId].setData(editRow.find('.data-value').html());
        dlg_textbaustein.dialog('open');
    });

    $('.icon-trash.deleteTB').on('click', function (event) {
        if (confirm('Sicher das Sie diesen Textbaustein permanent löschen wollen?')) {
            const textBlockId = $(this).attr('data-id');
            const blockData = {
                data: {
                    type: 'del',
                    id: textBlockId
                }
            };
            postData('', 'del', blockData);
        }
    });

    function postData(htmlText, type = 'save', blockData = null) {
        if ($('#blockId').val() != '0') {
            type = 'edit';
        }
        if (!blockData) {
            blockData = {
                data: {
                    type: type,
                    id: $('#blockId').val(),
                    title: $('#blockTitle').val(),
                    value: htmlText
                }
            };
        }

        $.ajax({
            type: 'POST',
            url: '/Handler/HvD/Textblock',
            data: blockData
        })
            .done(function (data) {
                if (data == 'ok') {
                    location.reload();
                } else if (data == 'ok') {
                    editRow.find('.data-title').text($('#blockTitle').val());
                    editRow.find('.data-value').html(htmlText);
                    tools.toast('Textbaustein', 'Textbaustein gespeichert');
                }
            })
            .fail(function (data, textStatus, errorThrown) {
                console.debug(textStatus);
                console.debug(errorThrown);
            });
    }
};
window.setTimeout(init, 200);
